exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".apiaccesslog{color:red}.text-detail{margin-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/apiaccesslog/apiaccesslog.scss
// module id = 774
// module chunks = 0